﻿import * as React from 'react';
import { Form, Button, FormGroup, FormFeedback, Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';

export const useForm = (callback: any, initialState = {}) => {
    const [values, setValues] = React.useState(initialState);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) =>
        setValues(
            { ...values, [event.target.name]: event.target.value }
        );

    // onSubmit
    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        await callback();   // triggering the callback
    };

    return {
        onChange,
        onSubmit,
        values
    };
}

function ContactForm() {
    const initialState = {
        name: '',
        email: '',
        phone: '',
        companyid: 4,
        templateid: 3,
    };

    const { onChange, onSubmit, values } = useForm(
        sendMessageCallback,
        initialState
    );

    async function sendMessageCallback() {
        var data = values;
        var form = document.getElementById("contact_form");
        var confirmation = document.getElementById("contact_form_confirmation");

        if (form) {
            form.classList.remove("visible");
        }

        if (confirmation) {
            confirmation.classList.add("visible");
        }


        fetch("https://iscfwebapp.azurewebsites.net/api/notification/send", {
            "method": "POST",
            "headers": {
                "content-type": "application/json",
                "accept": "application/json"
            },
            "body": JSON.stringify(values)
            })
            .then(response => response.json())
            .then(response => {
                console.log(response)
            })
            .catch(err => {
                console.log(err);
            });
    }

    return (
        <div className="form-panel">
            <Form id="contact_form" className="form visible" onSubmit={onSubmit}>
                <FormGroup>
                    <Label for="customerName">Name</Label>
                    <Input
                        type="text"
                        name="name"
                        id="customerName"
                        placeholder="Enter first and last name"
                        onChange={onChange}
                        required
                    />
                    <FormFeedback>
                        Uh oh! Don't forget to place your name.
                    </FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Label for="customerPhone">Phone Number</Label>
                    <Input
                        type="text"
                        name="phone"
                        id="customerPhone"
                        placeholder="(999)999-9999"
                        onChange={onChange}
                    />
                    <FormFeedback>
                        Uh oh! Looks like there is an issue with your phone number.  Please input a correct phone.
                    </FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Label for="customerEmail">Email</Label>
                    <Input
                        type="email"
                        name="email"
                        id="customerEmail"
                        placeholder="example@example.com"
                        onChange={onChange}
                        required
                    />
                    <FormFeedback>
                        Uh oh! Looks like there is an issue with your email. Please input a correct email.
                    </FormFeedback>
                </FormGroup>
                <div className="action">
                    <Button color="primary">Submit</Button>
                </div>
            </Form>
            <div id="contact_form_confirmation" className="form-confirmation">
                Thank you! One of our support representative will be contacting you shortly.
            </div>
        </div>
    );
}

export default ContactForm
